// extracted by mini-css-extract-plugin
export var root = "LayoutOption-module--root--9316a";
export var layoutIconContainer = "LayoutOption-module--layoutIconContainer--a412d";